import { Popup } from '../../../../../components/Popup'
import { useContractDetailsPopup } from '../../../Providers/ContractDetailsPopupProvider'
import { Typography } from '../../../../../components/Typography'
import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { BTN_TXT } from '../../../../../constants'
import { useCallback, useEffect, useState } from 'react'
import { useContractDetailsContext } from '../../../Providers/ContractDetailsContextProvider'
import { TextArea } from '../../../../../components/Input/input.textarea'
import './styles.scss'

export const ViewNotePopup = () => {
  const {
    addNotePopup: {
      state,
      actions: { close }
    }
  } = useContractDetailsPopup()

  const {
    state: { details },
    actions: { updateContractNote }
  } = useContractDetailsContext()

  const [editableNote, setEditableNote] = useState<string | null>(null)

  const onSaveNote = useCallback(() => {
    updateContractNote(editableNote ?? '')
  }, [editableNote, updateContractNote])

  const onClose = useCallback(() => {
    setEditableNote(details.note?.text ?? '')
    close()
  }, [details, close])

  useEffect(() => {
    setEditableNote(details.note?.text ?? '')
  }, [details.note])

  return (
    <Popup
      {...state}
      onCancel={onClose}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={onClose} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button type={BUTTON_TYPES.PRIMARY} onClick={onSaveNote} upperCase>
            {BTN_TXT.SAVE}
          </Button>
        </>
      }
    >
      <div className="view-note-popup__content">
        <div className="column gap-12">
          <Typography.Caption className="view-note-popup__content__caption">
            Notes about this contract (e.g. custom contract number). Visible
            only for users from your Health System.
          </Typography.Caption>
          <TextArea
            propsTextArea={{
              onChange: (e) => setEditableNote(e.target.value),
              value: editableNote ?? '',
              maxLength: 255
            }}
          />
        </div>
      </div>
    </Popup>
  )
}
